// Icône « layer » de l'en-tête du widget Flux supply (Figma 10715:61944), exportée par le design.
export function LayerIcon({ className }: { className?: string }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M9.60573 4.81273C10.7856 4.27075 11.3755 3.99976 12 3.99976C12.6245 3.99976 13.2144 4.27075 14.3943 4.81273L19.2873 7.06039C21.0958 7.89113 22 8.30649 22 8.99976C22 9.69302 21.0958 10.1084 19.2873 10.9391L14.3943 13.1868C13.2144 13.7288 12.6245 13.9998 12 13.9998C11.3755 13.9998 10.7856 13.7288 9.60573 13.1868L4.7127 10.9391C2.90423 10.1084 2 9.69302 2 8.99976C2 8.30649 2.90423 7.89113 4.7127 7.06039L9.60573 4.81273Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.2327 13.4998C21.4109 14.0618 22 14.4403 22 14.9999C22 15.6931 21.0958 16.1085 19.2873 16.9392L14.3943 19.1869C13.2144 19.7289 12.6245 19.9999 12 19.9999C11.3755 19.9999 10.7856 19.7289 9.60573 19.1869L4.7127 16.9392C2.90423 16.1085 2 15.6931 2 14.9999C2 14.4403 2.58909 14.0618 3.76727 13.4998"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

// Chevron `chevron-right-01-round` du design system (Figma 10781:27224), replacé dans sa boîte
// 24 × 24 : le tracé exporté occupe x 9→15, y 6→18.
export function ChevronRightRoundIcon({ className }: { className?: string }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M9 6C9 6 15 10.419 15 12C15 13.5812 9 18 9 18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
